import { type InsuranceProductDetailsDataFragment } from '../../../../api/fragments/InsuranceProductDetailsData';
// eslint-disable-next-line max-len
import { type InsuranceProductDetailsWithPermissionsDataFragment } from '../../../../api/fragments/InsuranceProductDetailsWithPermissionsData';
import { InsuranceProductKind, type InsuranceProductSettings } from '../../../../api/types';

export type InsuranceProductDetailsInnerPageProps = {
    insurance: InsuranceProductDetailsWithPermissionsDataFragment;
};

export const getUpdateInitialValue = (
    insurance?: Omit<InsuranceProductDetailsDataFragment, 'variants'>
): InsuranceProductFormValues => insurance;

export const initialValues: InsuranceProductSettings = {
    displayName: '',
    identifier: null,
    insurerId: null,
    isActive: false,
    legalName: {
        defaultValue: '',
        overrides: [],
    },
    moduleId: null,
    order: 0,
    period: null,
    kind: InsuranceProductKind.Local,
    type: null,
    description: {
        defaultValue: '',
        overrides: [],
    },
    variantSuiteIds: [],
    vehicleReferenceParameters: {
        variant: { engineType: [], isAddOnSpecificVehicles: false },
        finderVehicle: {
            engineType: [],
            isAddOnSpecificVehicles: false,
            conditions: [],
        },
    },
};

export const colSpan = { lg: 8, xs: 24 };

export type InsuranceProductFormValues = Omit<InsuranceProductDetailsDataFragment, 'permissions' | 'variants'>;
